import { IUser } from "~/types/types";

export default function isVerifiedUser(user: Pick<IUser, "verified"> | null) {
  if (!user) {
    return false;
  }

  return user.verified;
}
